 
import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-filter-card',
  imports: [CommonModule],
  standalone: true,
  providers: [],
  templateUrl: './dashboard-filter-card.component.html',
  styleUrl: './dashboard-filter-card.component.scss',
})
export class DashboardFilterCardComponent {
  @Input() title = '';
  @ContentChild(TemplateRef) template?: TemplateRef<any>;
}
